import React from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import Header from "../../stories/components/Header.js";
import LogoTableRow from "../../stories/components/LogoTableRow.js";
import LogoTableHead from "../../stories/components/LogoTableHead.js";

import {
  LogoOestfoldBuskerudOsloOgAkershusPrimaerBokmaalNegativPdf,
  LogoOestfoldBuskerudOsloOgAkershusPrimaerBokmaalNegativPng,
  LogoOestfoldBuskerudOsloOgAkershusPrimaerBokmaalNegativSvg,
  LogoOestfoldBuskerudOsloOgAkershusPrimaerBokmaalPositivPdf,
  LogoOestfoldBuskerudOsloOgAkershusPrimaerBokmaalPositivPng,
  LogoOestfoldBuskerudOsloOgAkershusPrimaerBokmaalPositivSvg,
  LogoOestfoldBuskerudOsloOgAkershusPrimaerNynorskNegativPdf,
  LogoOestfoldBuskerudOsloOgAkershusPrimaerNynorskNegativPng,
  LogoOestfoldBuskerudOsloOgAkershusPrimaerNynorskNegativSvg,
  LogoOestfoldBuskerudOsloOgAkershusPrimaerNynorskPositivPdf,
  LogoOestfoldBuskerudOsloOgAkershusPrimaerNynorskPositivPng,
  LogoOestfoldBuskerudOsloOgAkershusPrimaerNynorskPositivSvg,
  LogoOestfoldBuskerudOsloOgAkershusSekundaerBokmaalNegativPdf,
  LogoOestfoldBuskerudOsloOgAkershusSekundaerBokmaalNegativPng,
  LogoOestfoldBuskerudOsloOgAkershusSekundaerBokmaalNegativSvg,
  LogoOestfoldBuskerudOsloOgAkershusSekundaerBokmaalPositivPdf,
  LogoOestfoldBuskerudOsloOgAkershusSekundaerBokmaalPositivPng,
  LogoOestfoldBuskerudOsloOgAkershusSekundaerBokmaalPositivSvg,
  LogoOestfoldBuskerudOsloOgAkershusSekundaerNynorskNegativPdf,
  LogoOestfoldBuskerudOsloOgAkershusSekundaerNynorskNegativPng,
  LogoOestfoldBuskerudOsloOgAkershusSekundaerNynorskNegativSvg,
  LogoOestfoldBuskerudOsloOgAkershusSekundaerNynorskPositivPdf,
  LogoOestfoldBuskerudOsloOgAkershusSekundaerNynorskPositivPng,
  LogoOestfoldBuskerudOsloOgAkershusSekundaerNynorskPositivSvg,
  LogoOestfoldBuskerudOsloOgAkershusPrimaerBokmaalEngelskNegativPdf,
  LogoOestfoldBuskerudOsloOgAkershusPrimaerBokmaalEngelskNegativPng,
  LogoOestfoldBuskerudOsloOgAkershusPrimaerBokmaalEngelskNegativSvg,
  LogoOestfoldBuskerudOsloOgAkershusPrimaerBokmaalEngelskPositivPdf,
  LogoOestfoldBuskerudOsloOgAkershusPrimaerBokmaalEngelskPositivPng,
  LogoOestfoldBuskerudOsloOgAkershusPrimaerBokmaalEngelskPositivSvg,
  LogoOestfoldBuskerudOsloOgAkershusPrimaerNynorskEngelskNegativPdf,
  LogoOestfoldBuskerudOsloOgAkershusPrimaerNynorskEngelskNegativPng,
  LogoOestfoldBuskerudOsloOgAkershusPrimaerNynorskEngelskNegativSvg,
  LogoOestfoldBuskerudOsloOgAkershusPrimaerNynorskEngelskPositivPdf,
  LogoOestfoldBuskerudOsloOgAkershusPrimaerNynorskEngelskPositivPng,
  LogoOestfoldBuskerudOsloOgAkershusPrimaerNynorskEngelskPositivSvg,
  LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertBokmaalNegativPdf,
  LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertBokmaalNegativPng,
  LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertBokmaalNegativSvg,
  LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertBokmaalPositivPdf,
  LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertBokmaalPositivPng,
  LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertBokmaalPositivSvg,
  LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertNynorskNegativPdf,
  LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertNynorskNegativPng,
  LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertNynorskNegativSvg,
  LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertNynorskPositivPdf,
  LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertNynorskPositivPng,
  LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertNynorskPositivSvg,
  LogoOestfoldBuskerudOsloOgAkershusSekundaerBokmaalEngelskNegativPdf,
  LogoOestfoldBuskerudOsloOgAkershusSekundaerBokmaalEngelskNegativPng,
  LogoOestfoldBuskerudOsloOgAkershusSekundaerBokmaalEngelskNegativSvg,
  LogoOestfoldBuskerudOsloOgAkershusSekundaerBokmaalEngelskPositivPdf,
  LogoOestfoldBuskerudOsloOgAkershusSekundaerBokmaalEngelskPositivPng,
  LogoOestfoldBuskerudOsloOgAkershusSekundaerBokmaalEngelskPositivSvg,
  LogoOestfoldBuskerudOsloOgAkershusSekundaerNynorskEngelskNegativPdf,
  LogoOestfoldBuskerudOsloOgAkershusSekundaerNynorskEngelskNegativPng,
  LogoOestfoldBuskerudOsloOgAkershusSekundaerNynorskEngelskNegativSvg,
  LogoOestfoldBuskerudOsloOgAkershusSekundaerNynorskEngelskPositivPdf,
  LogoOestfoldBuskerudOsloOgAkershusSekundaerNynorskEngelskPositivPng,
  LogoOestfoldBuskerudOsloOgAkershusSekundaerNynorskEngelskPositivSvg,
  LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertBokmaalNegativPdf,
  LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertBokmaalNegativPng,
  LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertBokmaalNegativSvg,
  LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertBokmaalPositivPdf,
  LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertBokmaalPositivPng,
  LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertBokmaalPositivSvg,
  LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertNynorskNegativPdf,
  LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertNynorskNegativPng,
  LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertNynorskNegativSvg,
  LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertNynorskPositivPdf,
  LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertNynorskPositivPng,
  LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertNynorskPositivSvg,
  LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertBokmaalEngelskNegativPdf,
  LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertBokmaalEngelskNegativPng,
  LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertBokmaalEngelskNegativSvg,
  LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertBokmaalEngelskPositivPdf,
  LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertBokmaalEngelskPositivPng,
  LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertBokmaalEngelskPositivSvg,
  LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertNynorskEngelskNegativPdf,
  LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertNynorskEngelskNegativPng,
  LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertNynorskEngelskNegativSvg,
  LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertNynorskEngelskPositivPdf,
  LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertNynorskEngelskPositivPng,
  LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertNynorskEngelskPositivSvg,
  LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertBokmaalEngelskNegativPdf,
  LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertBokmaalEngelskNegativPng,
  LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertBokmaalEngelskNegativSvg,
  LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertBokmaalEngelskPositivPdf,
  LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertBokmaalEngelskPositivPng,
  LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertBokmaalEngelskPositivSvg,
  LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertNynorskEngelskNegativPdf,
  LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertNynorskEngelskNegativPng,
  LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertNynorskEngelskNegativSvg,
  LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertNynorskEngelskPositivPdf,
  LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertNynorskEngelskPositivPng,
  LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertNynorskEngelskPositivSvg,
} from "../../assets/logo/Oestfold-Buskerud-Oslo-og-Akershus/exsportOestfoldBuskerudOsloOgAkershus.js";

export default function OestfoldBuskerudOsloOgAkershusPage() {
  return (
    <Container className="mb-6">
      <article>
        <Header
          title="Logofiler for Statsforvalteren i Østfold, Buskerud, Oslo og Akershus"
          lead="Alle logoer for Østfold, Buskerud, Oslo og Akershus i ulike variasjoner og filformater. "
          breadcrumbText="Tilbake til logo"
          breadcrumbUrl="/logo"
        />
        <main>
          <Row>
            <Col md={{ span: 8, offset: 2 }}>
              <center><b>Gjelder fra 1. juli 2024</b></center>
            </Col>
          </Row>
          <Row className="my-6">
            <Col>
              <h4>Primærlogo</h4>
              <Table responsive size="lg" className="table-simple">
                <LogoTableHead />
                <tbody>
                <LogoTableRow
                    logoUrl={LogoOestfoldBuskerudOsloOgAkershusPrimaerBokmaalPositivSvg}
                    title="Primærlogo: Statsforvalteren i Østfold, Buskerud, Oslo og Akershus, bokmål"
                    text="Bokmål"
                    blackSvg={LogoOestfoldBuskerudOsloOgAkershusPrimaerBokmaalPositivSvg}
                    blackPng={LogoOestfoldBuskerudOsloOgAkershusPrimaerBokmaalPositivPng}
                    blackPdf={LogoOestfoldBuskerudOsloOgAkershusPrimaerBokmaalPositivPdf}
                    whiteSvg={LogoOestfoldBuskerudOsloOgAkershusPrimaerBokmaalNegativSvg}
                    whitePng={LogoOestfoldBuskerudOsloOgAkershusPrimaerBokmaalNegativPng}
                    whitePdf={LogoOestfoldBuskerudOsloOgAkershusPrimaerBokmaalNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoOestfoldBuskerudOsloOgAkershusPrimaerBokmaalEngelskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Østfold, Buskerud, Oslo og Akershus, bokmål + engelsk"
                    text="Bokmål + engelsk"
                    blackSvg={LogoOestfoldBuskerudOsloOgAkershusPrimaerBokmaalEngelskPositivSvg}
                    blackPng={LogoOestfoldBuskerudOsloOgAkershusPrimaerBokmaalEngelskPositivPng}
                    blackPdf={LogoOestfoldBuskerudOsloOgAkershusPrimaerBokmaalEngelskPositivPdf}
                    whiteSvg={LogoOestfoldBuskerudOsloOgAkershusPrimaerBokmaalEngelskNegativSvg}
                    whitePng={LogoOestfoldBuskerudOsloOgAkershusPrimaerBokmaalEngelskNegativPng}
                    whitePdf={LogoOestfoldBuskerudOsloOgAkershusPrimaerBokmaalEngelskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoOestfoldBuskerudOsloOgAkershusPrimaerNynorskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Østfold, Buskerud, Oslo og Akershus, nynorsk"
                    text="Nynorsk"
                    blackSvg={LogoOestfoldBuskerudOsloOgAkershusPrimaerNynorskPositivSvg}
                    blackPng={LogoOestfoldBuskerudOsloOgAkershusPrimaerNynorskPositivPng}
                    blackPdf={LogoOestfoldBuskerudOsloOgAkershusPrimaerNynorskPositivPdf}
                    whiteSvg={LogoOestfoldBuskerudOsloOgAkershusPrimaerNynorskNegativSvg}
                    whitePng={LogoOestfoldBuskerudOsloOgAkershusPrimaerNynorskNegativPng}
                    whitePdf={LogoOestfoldBuskerudOsloOgAkershusPrimaerNynorskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoOestfoldBuskerudOsloOgAkershusPrimaerNynorskEngelskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Østfold, Buskerud, Oslo og Akershus, nynorsk + engelsk"
                    text="Nynorsk + engelsk"
                    blackSvg={LogoOestfoldBuskerudOsloOgAkershusPrimaerNynorskEngelskPositivSvg}
                    blackPng={LogoOestfoldBuskerudOsloOgAkershusPrimaerNynorskEngelskPositivPng}
                    blackPdf={LogoOestfoldBuskerudOsloOgAkershusPrimaerNynorskEngelskPositivPdf}
                    whiteSvg={LogoOestfoldBuskerudOsloOgAkershusPrimaerNynorskEngelskNegativSvg}
                    whitePng={LogoOestfoldBuskerudOsloOgAkershusPrimaerNynorskEngelskNegativPng}
                    whitePdf={LogoOestfoldBuskerudOsloOgAkershusPrimaerNynorskEngelskNegativPdf}
                  />
                </tbody>
              </Table>
            </Col>
          </Row>
          <Row className="my-6">
            <Col>
              <h4>Sekundærlogo</h4>
              <Table responsive size="lg" className="table-simple">
                <LogoTableHead />
                <tbody>
                <LogoTableRow
                    logoUrl={LogoOestfoldBuskerudOsloOgAkershusSekundaerBokmaalPositivSvg}
                    title="Primærlogo: Statsforvalteren i Østfold, Buskerud, Oslo og Akershus, bokmål"
                    text="Bokmål"
                    blackSvg={LogoOestfoldBuskerudOsloOgAkershusSekundaerBokmaalPositivSvg}
                    blackPng={LogoOestfoldBuskerudOsloOgAkershusSekundaerBokmaalPositivPng}
                    blackPdf={LogoOestfoldBuskerudOsloOgAkershusSekundaerBokmaalPositivPdf}
                    whiteSvg={LogoOestfoldBuskerudOsloOgAkershusSekundaerBokmaalNegativSvg}
                    whitePng={LogoOestfoldBuskerudOsloOgAkershusSekundaerBokmaalNegativPng}
                    whitePdf={LogoOestfoldBuskerudOsloOgAkershusSekundaerBokmaalNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoOestfoldBuskerudOsloOgAkershusSekundaerBokmaalEngelskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Østfold, Buskerud, Oslo og Akershus, bokmål + engelsk"
                    text="Bokmål + engelsk"
                    blackSvg={LogoOestfoldBuskerudOsloOgAkershusSekundaerBokmaalEngelskPositivSvg}
                    blackPng={LogoOestfoldBuskerudOsloOgAkershusSekundaerBokmaalEngelskPositivPng}
                    blackPdf={LogoOestfoldBuskerudOsloOgAkershusSekundaerBokmaalEngelskPositivPdf}
                    whiteSvg={LogoOestfoldBuskerudOsloOgAkershusSekundaerBokmaalEngelskNegativSvg}
                    whitePng={LogoOestfoldBuskerudOsloOgAkershusSekundaerBokmaalEngelskNegativPng}
                    whitePdf={LogoOestfoldBuskerudOsloOgAkershusSekundaerBokmaalEngelskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoOestfoldBuskerudOsloOgAkershusSekundaerNynorskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Østfold, Buskerud, Oslo og Akershus, nynorsk"
                    text="Nynorsk"
                    blackSvg={LogoOestfoldBuskerudOsloOgAkershusSekundaerNynorskPositivSvg}
                    blackPng={LogoOestfoldBuskerudOsloOgAkershusSekundaerNynorskPositivPng}
                    blackPdf={LogoOestfoldBuskerudOsloOgAkershusSekundaerNynorskPositivPdf}
                    whiteSvg={LogoOestfoldBuskerudOsloOgAkershusSekundaerNynorskNegativSvg}
                    whitePng={LogoOestfoldBuskerudOsloOgAkershusSekundaerNynorskNegativPng}
                    whitePdf={LogoOestfoldBuskerudOsloOgAkershusSekundaerNynorskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoOestfoldBuskerudOsloOgAkershusSekundaerNynorskEngelskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Østfold, Buskerud, Oslo og Akershus, nynorsk + engelsk"
                    text="Nynorsk + engelsk"
                    blackSvg={LogoOestfoldBuskerudOsloOgAkershusSekundaerNynorskEngelskPositivSvg}
                    blackPng={LogoOestfoldBuskerudOsloOgAkershusSekundaerNynorskEngelskPositivPng}
                    blackPdf={LogoOestfoldBuskerudOsloOgAkershusSekundaerNynorskEngelskPositivPdf}
                    whiteSvg={LogoOestfoldBuskerudOsloOgAkershusSekundaerNynorskEngelskNegativSvg}
                    whitePng={LogoOestfoldBuskerudOsloOgAkershusSekundaerNynorskEngelskNegativPng}
                    whitePdf={LogoOestfoldBuskerudOsloOgAkershusSekundaerNynorskEngelskNegativPdf}
                  />
                </tbody>
              </Table>
            </Col>
          </Row>
          <Row className="my-6">
            <Col>
              <h4>Sentrert Primærlogo</h4>
              <Table responsive size="lg" className="table-simple">
                <LogoTableHead />
                <tbody>
                  <LogoTableRow
                    logoUrl={LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertBokmaalPositivSvg}
                    title="Sentrert primærlogo: Statsforvalteren i Østfold, Buskerud, Oslo og Akershus, bokmål"
                    text="Bokmål"
                    blackSvg={LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertBokmaalPositivSvg}
                    blackPng={LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertBokmaalPositivPng}
                    blackPdf={LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertBokmaalPositivPdf}
                    whiteSvg={LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertBokmaalNegativSvg}
                    whitePng={LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertBokmaalNegativPng}
                    whitePdf={LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertBokmaalNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertBokmaalEngelskPositivSvg}
                    title="Sentrert primærlogo: Statsforvalteren i Østfold, Buskerud, Oslo og Akershus, bokmål + engelsk"
                    text="Bokmål + engelsk"
                    blackSvg={LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertBokmaalEngelskPositivSvg}
                    blackPng={LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertBokmaalEngelskPositivPng}
                    blackPdf={LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertBokmaalEngelskPositivPdf}
                    whiteSvg={LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertBokmaalEngelskNegativSvg}
                    whitePng={LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertBokmaalEngelskNegativPng}
                    whitePdf={LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertBokmaalEngelskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertNynorskPositivSvg}
                    title="Sentrert primærlogo: Statsforvalteren i Østfold, Buskerud, Oslo og Akershus, nynorsk"
                    text="Nynorsk"
                    blackSvg={LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertNynorskPositivSvg}
                    blackPng={LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertNynorskPositivPng}
                    blackPdf={LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertNynorskPositivPdf}
                    whiteSvg={LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertNynorskNegativSvg}
                    whitePng={LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertNynorskNegativPng}
                    whitePdf={LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertNynorskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertNynorskEngelskPositivSvg}
                    title="Sentrert primærlogo: Statsforvalteren i Østfold, Buskerud, Oslo og Akershus, nynorsk + engelsk"
                    text="Nynorsk + engelsk"
                    blackSvg={LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertNynorskEngelskPositivSvg}
                    blackPng={LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertNynorskEngelskPositivPng}
                    blackPdf={LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertNynorskEngelskPositivPdf}
                    whiteSvg={LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertNynorskEngelskNegativSvg}
                    whitePng={LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertNynorskEngelskNegativPng}
                    whitePdf={LogoOestfoldBuskerudOsloOgAkershusPrimaerSentrertNynorskEngelskNegativPdf}
                  />
                </tbody>
              </Table>
            </Col>  
          </Row>
          <Row className="my-6">
            <Col>
              <h4>Sentrert Sekundærlogo</h4>
              <Table responsive size="lg" className="table-simple">
                <LogoTableHead />
                <tbody>
                  <LogoTableRow
                    logoUrl={LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertBokmaalPositivSvg}
                    title="Sentrert sekundærlogo: Statsforvalteren i Østfold, Buskerud, Oslo og Akershus, bokmål"
                    text="Bokmål"
                    blackSvg={LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertBokmaalPositivSvg}
                    blackPng={LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertBokmaalPositivPng}
                    blackPdf={LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertBokmaalPositivPdf}
                    whiteSvg={LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertBokmaalNegativSvg}
                    whitePng={LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertBokmaalNegativPng}
                    whitePdf={LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertBokmaalNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertBokmaalEngelskPositivSvg}
                    title="Sentrert sekundærlogo: Statsforvalteren i Østfold, Buskerud, Oslo og Akershus, bokmål + engelsk"
                    text="Bokmål + engelsk"
                    blackSvg={LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertBokmaalEngelskPositivSvg}
                    blackPng={LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertBokmaalEngelskPositivPng}
                    blackPdf={LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertBokmaalEngelskPositivPdf}
                    whiteSvg={LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertBokmaalEngelskNegativSvg}
                    whitePng={LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertBokmaalEngelskNegativPng}
                    whitePdf={LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertBokmaalEngelskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertNynorskPositivSvg}
                    title="Sentrert sekundærlogo: Statsforvalteren i Østfold, Buskerud, Oslo og Akershus, nynorsk"
                    text="Nynorsk"
                    blackSvg={LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertNynorskPositivSvg}
                    blackPng={LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertNynorskPositivPng}
                    blackPdf={LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertNynorskPositivPdf}
                    whiteSvg={LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertNynorskNegativSvg}
                    whitePng={LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertNynorskNegativPng}
                    whitePdf={LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertNynorskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertNynorskEngelskPositivSvg}
                    title="Sentrert sekundærlogo: Statsforvalteren i Østfold, Buskerud, Oslo og Akershus, nynorsk + engelsk"
                    text="Nynorsk + engelsk"
                    blackSvg={LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertNynorskEngelskPositivSvg}
                    blackPng={LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertNynorskEngelskPositivPng}
                    blackPdf={LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertNynorskEngelskPositivPdf}
                    whiteSvg={LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertNynorskEngelskNegativSvg}
                    whitePng={LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertNynorskEngelskNegativPng}
                    whitePdf={LogoOestfoldBuskerudOsloOgAkershusSekundaerSentrertNynorskEngelskNegativPdf}
                  />
                </tbody>
              </Table>
            </Col>  
          </Row>
        </main>
      </article>
    </Container>
  );
}
